module.exports = __webpack_public_path__ + "static/media/office-view.bb590e9b.svg";